import { LatestNewsCardWebComponent } from './component/LatestNewsCardWebComponent';

export { LatestNewsCardWebComponent };
